import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../ui/Dialog/DialogTitle"
import DialogContent from "../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../ui/Dialog/DialogActions";
import AddQuizForm from '../AddQuizForm';

const styles = theme => ({
  dialog: {
    width: "480px"
  }
});

const AddQuizModal = ({
  open,
  handleClose,
  classes,
  history,
  isCreatingQuiz,
  createQuiz
}) => {
  const [formData, updateFormData] = React.useState(null);
  const [checked, setChecked] = React.useState(false);

  const onConfirm = () => {
    createQuiz(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Создать опрос</DialogTitle>
        <DialogContent>
          <AddQuizForm onFormChange={updateFormData}
          disabled={isCreatingQuiz}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            disabled={isCreatingQuiz || !formData}
            loading={isCreatingQuiz}
            onClick={() => onConfirm()}
            color="green">
            Создать
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(AddQuizModal));
